import { apiCacheKeys } from '@doltech/core/lib/api/api.urls';
import { withContextStore } from '@doltech/core/lib/entity/store';
import { queryClient } from '@doltech/core/lib/hooks/withReactQueryConfig';
import { ManagementPagination } from '@doltech/ui/lib/shared/components/PremadePagination/ManagementPagination';
import { TrendingMixSelectionModal } from '@doltech/ui/lib/shared/components/TrendingModal/TrendingMixSelectionModal';
import { TrendingPickupModalProps } from '@doltech/ui/lib/shared/components/TrendingModal/TrendingPickupModal';
import { compose } from '@doltech/utils/lib/compose';
import { observer } from 'mobx-react-lite';
import { getSnapshot } from 'mobx-state-tree';
import * as React from 'react';
import { useQuery } from 'react-query';

import { useFilterStore } from '@doltech/ui/lib/filter/Filter/FilterStore';
import { activeDailyFacts, getDailyFacts } from '../../../apis/daily-learning-facts.api';
import { FactSetupCard } from '../components/FactSetupCard';
import { FactModalFilterModel, FactModalFilterStore } from './models/fact-modal-filter.store';

interface FactSelectionModalProps extends TrendingPickupModalProps {}

const FactSelectionModalContent = (props: FactSelectionModalProps) => {
  const { visible } = props;
  const { modalFilter: filter } = useFilterStore<FactModalFilterStore>();

  const [updating, setUpdating] = React.useState(false);

  const { data, isLoading } = useQuery<any>(
    [apiCacheKeys.onlineTest.GET_DAILY_LEARNING_FACT, filter],
    () => {
      const filterValue = getSnapshot(filter);
      return getDailyFacts({
        ...filterValue,
        page: Math.max(filterValue.page - 1, 0),
      });
    },
    {
      enabled: visible,
    }
  );

  return (
    <TrendingMixSelectionModal
      maxSelection={1}
      data={data?.content}
      loading={isLoading || updating}
      renderCard={(cardData) => <FactSetupCard data={cardData} />}
      onSearch={(searchValue) => filter.updateSearch(searchValue)}
      onApply={async (selectedList) => {
        setUpdating(true);
        const id = selectedList[0];
        await activeDailyFacts({ id, payload: null });
        await queryClient.refetchQueries(apiCacheKeys.publicService.GET_ACTIVE_FACT);
        setUpdating(false);
      }}
      paginationElement={
        <ManagementPagination
          filter={filter}
          totalPages={data?.totalPages}
          totalElements={data?.totalElements}
        />
      }
      selectionFilters={[
        {
          key: 'ALL',
          group: 'main',
          render: () => 'All',
        },
      ]}
      defaultSelectedFilterKey="ALL"
      {...props}
    />
  );
};

export const FactSelectionModal: React.FunctionComponent<FactSelectionModalProps> = compose(
  withContextStore({
    modalFilter: {
      model: FactModalFilterModel,
      defaultValue: {
        page: 1,
        size: 6,
      },
    },
  }),
  observer
)(FactSelectionModalContent);
